import { createStore as _createStore, applyMiddleware, combineReducers, Store as rStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import reducers from './modules'
import { ApplicationState } from './modules/application'
import { AuthState } from './modules/auth'
import { InquiryState } from './modules/inquiry'
import { MoviesState } from './modules/movies'
import { NotificationsState } from './modules/notifications'
import { ReadingWordsState } from './modules/readingWords'
import { UsersState } from './modules/users'
import sagas from './sagas'

export type AppState = {
  application: ApplicationState
  auth: AuthState
  inquiry: InquiryState
  movies: MoviesState
  notifications: NotificationsState
  readingWords: ReadingWordsState
  users: UsersState
}

export type Store = rStore<AppState>

const saga = createSagaMiddleware()
const middlewares = [saga]
const createStore = applyMiddleware(...middlewares)(_createStore)
const store = createStore(combineReducers(reducers))

saga.run(sagas)

export default store
